export default "__VITE_ASSET__DeReGiVN__"